module.exports = __webpack_public_path__ + "static/media/close.ec2fdb4d.png";